// /login — layout route. Children (login.index, login.password-change,
// login.mfa-enroll, login.mfa-verify, login.recovery-codes) render here via
// <Outlet/>. The actual sign-in form lives in login.index.tsx.
//
// In TanStack Router's flat-file convention, dot-separated names create a
// parent/child hierarchy. Without this layout file's Outlet, none of the
// /login/* sub-routes would render — TSR would render the parent and stop.

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/login')({
  component: LoginLayout,
});

function LoginLayout() {
  return <Outlet />;
}
